import * as React from "react";
import "../../../assets/sass/components/reviewPopup.scss";
import { handleEnter, imagePathurl } from "../../utils/utils";
import Review from "./review";

const ReviewPopup: React.FC<any> = (props) => {
    const { onCancel } = props;
    //image CDN_PATH
    const maxHeight = Math.max(document.documentElement.scrollHeight, document.documentElement.clientHeight, 1500);
    const getimagePath = imagePathurl();
    return (
        <React.Fragment>
            <div className="form-container-block review-container-block" id="form-container">
                <div className="overlay" style={{ height: maxHeight }} onClick={() => onCancel()}>
                    <div
                        className="popup-container review-popup-container"
                        onClick={(e) => {
                            e.stopPropagation();
                        }}
                    >
                        <div
                            id="close_popup"
                            className="close-menu"
                            onClick={() => onCancel()}
                            onKeyPress={handleEnter}
                        >
                            <img className="popup-close-icon" src={`${getimagePath}close-mobile.png`} alt="close" />
                        </div>
                        <Review />
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default ReviewPopup;
